module.exports = __webpack_public_path__ + "static/media/volant-gris.a5249505.png";